import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { SortByEnum } from '#src/app/pages/search/shared/api';

type Result = ModelHookResult<{
	options: ReadonlyArray<{
		label: string;
		value: SortByEnum | '';
		subtitle: string;
		trackingContext: string;
	}>;
}>;

export function useSortOptions(): Result {
	const { translate } = useI18n();

	return {
		data: {
			options: useMemo(
				() => [
					{
						label: translate('corgi.search.sort.options.recent_activity'),
						value: '',
						subtitle: translate('corgi.search.sort.options.recent_activity_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.most_signatures'),
						value: 'most_signatures',
						subtitle: translate('corgi.search.sort.options.most_signatures_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.least_signatures'),
						value: 'least_signatures',
						subtitle: translate('corgi.search.sort.options.least_signatures_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.newest'),
						value: 'newest',
						subtitle: translate('corgi.search.sort.options.newest_subtitle'),
						trackingContext: '',
					},
				],
				[translate],
			),
		},
	};
}
